import { icons } from './icons';
import { rootSx } from './styles';

import type { SvgIconProps as MuiIconProps } from '@mui/material/SvgIcon/SvgIcon';
import type * as React from 'react';

export type BaseIconProps = Pick<
  MuiIconProps,
  'fontSize' | 'color' | 'className' | 'classes' | 'sx'
> & {
  text?: string;
};

export type IconName = keyof typeof icons;

export interface IconProps extends BaseIconProps {
  /** Name of defined icon. */
  icon: IconName;
  /** Fired when user clicks on Icon. */
  onClick?(): void;
}

const Icon: React.FC<IconProps> = (props) => {
  const { icon, className, sx = [], ...iconProps } = props;
  const SVGIcon = icons[icon];

  return (
    <SVGIcon
      {...iconProps}
      sx={[rootSx(iconProps), ...(Array.isArray(sx) ? sx : [sx])]}
      className={className}
    />
  );
};

export default Icon;
